import { createStore } from "solid-js/store";
import { isServer } from "solid-js/web";

import { LocalStorageKey } from "@/constants/constants";
import { useConfigRestrict } from "@/hooks/useConfigRestrict";
import { getServerTimestamp } from "@/lib/dateUtils";
import { setLocalStorageItem } from "@/lib/localStorage.ts";
import { getActivityState } from "@/stores/activityStore";
import { bonusCenterStore } from "@/stores/bonusCenterStore";
import { userStore } from "@/stores/userStore";
import {
  GetOffLineActivityConfigRsp,
  OfflineActivityConfig,
} from "@/types/swaggerex/activity";

export interface PromotionsStoreInterface {
  /** 活动列表 */
  activityList: OfflineActivityConfig[];
  /** 选择的活动列表 */
  chooseActivityList: OfflineActivityConfig[];
  /** 活动分类列表 */
  categoryList: { label: string; value: string }[];
  /** 当前活动分类 */
  tabActive: string;
  /** 是否正在加载 */
  isLoading: boolean;
  /** 全内容活动列表 */
  fullContentActivityList: Record<string, OfflineActivityConfig>;
}
// 原始数据
const originalStore: PromotionsStoreInterface = {
  activityList: [],
  chooseActivityList: [],
  categoryList: [],
  tabActive: "",
  fullContentActivityList: {},
  isLoading: false,
};

export const updateFullContentActivityList = (
  id: string,
  config: OfflineActivityConfig,
) => {
  setPromotionsStore("fullContentActivityList", {
    ...promotionsStore.fullContentActivityList,
    [id]: config,
  });
};
// 创建store
export const [promotionsStore, setPromotionsStore] =
  createStore<PromotionsStoreInterface>(
    JSON.parse(JSON.stringify(originalStore)),
  );
// 处理活动列表
export const handleActivityList = (list?: OfflineActivityConfig[]) => {
  const { getStatusByDeny } = useConfigRestrict();
  const actList = list || promotionsStore.activityList;
  const specialList = bonusCenterStore.specialList;
  const activityList = bonusCenterStore.bonusCenterCardData;
  const currentTimestamp = Date.now();
  return actList?.filter((item: OfflineActivityConfig) => {
    return (
      getStatusByDeny([...(item.deny_pack || [])], item.deny_pack_type, true) &&
      (userStore.isLogin && item.activity_type
        ? item.activity_type > 300
          ? specialList?.find((el) => item.activity_type == el.activity_type) !=
            undefined
          : getActivityState(item.activity_type) &&
            !activityList[item.activity_type]?.hide
        : true) &&
      (!item.etime || item.etime * 1000 > currentTimestamp) &&
      item.stime * 1000 < currentTimestamp
    );
  });
};
// 切换活动分类
export const changeTable = (value: string) => {
  setPromotionsStore("tabActive", value);
  const list = handleActivityList()?.filter((item: OfflineActivityConfig) => {
    return value ? item.category_id === value : true;
  });
  setPromotionsStore("chooseActivityList", list);
};
// 点击活动
export const clickActivity = (
  list: GetOffLineActivityConfigRsp["offine_activity_config"],
  push: (path: string) => void,
) => {
  setLocalStorageItem(
    LocalStorageKey.OFFLINE_ACTIVITY_DETAILS,
    JSON.stringify(list),
  );
  push("/promotion-details");
};
